import { addRolesToOrganisationUser, createOrganisationMachineClient, deleteOrganisationUser } from '@infuse/api/iam/organisation';
import { useGenericCreateMachineUser } from '@infuse/iam/user/mutations';

export const useCreateOrganisationMachineUser = () =>
  useGenericCreateMachineUser({
    apiFn: createOrganisationMachineClient,
    roleApiFn: addRolesToOrganisationUser,
    deleteApiFn: deleteOrganisationUser
  });
